module.exports = __webpack_public_path__ + "img/notification.93d06411.png";